module.exports = __webpack_public_path__ + "img/advisory_select_type_m.b016e48f.png";